import { render, staticRenderFns } from "./mod7EditNewBusinessForm.vue?vue&type=template&id=65a90813"
import script from "./mod7EditNewBusinessForm.vue?vue&type=script&lang=js"
export * from "./mod7EditNewBusinessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports